{
  "home": {
    "heroStop": "ЗУПИНИМО HUMAN SAFARI",
    "heroSave": "ВРЯТУЙТЕ ХЕРСОН",
    "heroDate": "13, 14 грудня",
    "worldwideRally": "світова акція",
    "heroTitle1": "Люди",
    "heroTitle2": "— не мішені.",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "З літа 2024 року російські війська використовують малі дрони для полювання, вбивств і терору цивільного населення на вулицях Херсона та інших прифронтових міст України. <bold>Сафарі на людей має припинитися. ВИ можете допомогти.</bold> Приєднуйтесь до тисяч людей по всьому світу, щоб вимагати зупинити цей воєнний злочин.",
    "seeGallery": "Плакати з усього світу",
    "comingSoon": "Локації з’являться незабаром",
    "december": "грудня",
    "dec": "груд.",
    "october": "жовтня",
    "oct": "жовт.",
    "september": "вересня",
    "sep": "вер.",
    "schedule9": "9",
    "schedule10": "10",
    "schedule11": "11",
    "schedule12": "12",
    "schedule13": "13",
    "schedule14": "14",
    "schedule16": "16",
    "schedule18": "18",
    "schedule20": "20",
    "schedule1": "1",
    "schedule2": "2",
    "schedule3": "3",
    "schedule4": "4",
    "schedule5": "5",
    "schedule25": "25",
    "schedule26": "26",
    "schedule27": "27",
    "schedule28": "28",
    "schedule29": "29",
    "schedule30": "30",
    "schedule31": "31",
    "scheduleTBC": "Дата уточнюється...",
    "recommendationsTitle": "Рекомендації Комісії ООН",
    "recommendationsRussia": "Комісія рекомендує Російській Федерації:",
    "rusRec1": "(a) Негайно припинити атаки дронів, спрямовані на цивільних та цивільні об'єкти",
    "rusRec2": "(b) Негайно припинити всі дії, що поширюють терор серед цивільного населення",
    "rusRec3": "(c) Забезпечити, щоб усі винні у атаках дронів на цивільних були притягнуті до відповідальності",
    "recommendationsUNStates": "Комісія рекомендує іншим державам та регіональним і міжнародним організаціям:",
    "statesRec1": "(a) Надати фінансову та технічну підтримку уряду України та організаціям громадянського суспільства для комплексної допомоги постраждалим та їхнім родинам;",
    "statesRec2": "(b) Для третіх держав, територія яких є пунктом призначення для осіб, депортованих з окупованих територій, вжити необхідних заходів разом з українськими консульськими службами для підтримки цих осіб."
  },
  "resources": {
    "title": "Ключові ресурси",
    "linkLibraryTitle": "Бібліотека посилань",
    "linkLibraryDesc": "200 статей, звітів, інтерв’ю, свідчень очевидців та медіа-покриття",
    "humanSafariMapTitle": "Мапа «людського сафарі» від Tochnyi",
    "humanSafariMapDesc": "Інтерактивна мапа атак «людського сафарі» в Херсоні, зібрана з відкритих повідомлень місцевої влади та з відео атак, які геолокувала команда Tochnyi.",
    "truthHoundsTitle": "Звіт Truth Hounds",
    "truthHoundsDesc": "Killzone: Як російські дрони нищать правий берег річки Дніпро",
    "hrwTitle": "Звіт Human Rights Watch про атаки дронів у Херсоні",
    "hrwDesc": "HRW Звіт",
    "unReportsTitle": "Звіти Ради ООН з прав людини",
    "report1": "Звіт ООН #1",
    "report3": "Звіт ООН #3",
    "guidelines": "Рекомендації ООН",
    "wikipediaTitle": "Вікіпедія",
    "english": "Англійська",
    "french": "Французька",
    "documentaryTitle": "Документальний фільм",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13-14 грудня",
    "eyewitnesses": "Свідки",
    "rallies": "фото",
    "help": "деокупована Херсонщина",
    "leftBank": "окупована Херсонщина",
    "action": "грудня '25",
    "oleshky": "глобальна акція - Олешки",
    "menu": "Меню"
  },
  "leftBank": {
    "pageTitle": "Дронова облога",
    "para1": "Гостра гуманітарна криза охопила 6000 цивільних, які опинилися в пастці дронової облоги в окупованих Олешках, Голій Пристані, Старій Збур'ївці та Новій Збур'ївці - окупована Херсонщина. В Олешках 1200 - 2000. Окупаційна влада зобов'язана підтримувати їх - натомість російські війська використовують їх як живий щит, щоб ховатися за цим населенням, здійснюючи атаки «людського сафарі» на протилежному березі. Українська влада та гуманітарні організації повідомляють про систематичне перешкоджання евакуації та гуманітарному доступу.",
    "para2": "Цивільні не мають їжі, води, медичної допомоги, ліків, електрики, газу та зв'язку. Дороги густо заміновані, а активність дронів обмежує пересування. Із 26 травня жоден автомобіль не зміг ані в'їхати, ані виїхати. Запаси пального та продовольства майже вичерпані.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Відео: «Kherson and Oleshky: Witnessing Genocide» (12 хв)",
    "meidasArticle": "Стаття: «The Kherson Region: How Russia Uses Civilians as a Tool of War» (5 хв читання)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Стаття: «Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate» (7 хв читання)",
    "tellPost": "і розповідайте іншим про Дронову облогу",
    "callToHelp": "ВИ можете допомогти. Ось як",
    "donateIntro": "Це ініціативи, які надають дієву й адресну допомогу безпосередньо людям, що виїхали з Олешок або, де це можливо, залишаються там у пастці.",
    "signTitle": "Підпишіть",
    "signSub": "петиції",
    "petitionBy": "від {{name}}",
    "petitions": {
      "euParliament": "Європейський парламент – Петиція № 1439/2026 щодо створення гуманітарного коридору для евакуації цивільних, які опинилися в облозі в окупованих росією Олешках",
      "ukParliament": "Парламент Великої Британії – Запровадити гуманітарний коридор до Олешок під проводом Великої Британії"
    },
    "publicActionLead": "Привертайте увагу до дронової облоги там, де ви є.",
    "organiseAction": "Організуйте акцію.",
    "policyBody": "Українська влада проводить консультації з Міжнародним комітетом Червоного Хреста щодо створення гуманітарного коридору для евакуації з окупованих населених пунктів Херсонської області та забезпечення гуманітарного доступу для постачання їжі, води, ліків, пального та медичної допомоги. Станом на початок червня жодного діючого коридору евакуації чи сталого механізму гуманітарного доступу немає.",
    "documentaryTitle": "Олешки, короткий документальний фільм",
    "downloadTitle": "Завантажити",
    "downloadSub": "графіка"
  },
  "footer": {
    "addCityText": "Щоб додати своє місто, надішліть електронний лист на: ",
    "organiseText": "Додайте свою акцію - зв'яжіться з нами:",
    "contact": "Контакт:"
  },
  "witnesses": {
    "title": " Ми збираємо свідчення!",
    "email": "Якщо ви з Херсона, Нікополя, Запоріжжя, Сум чи прифронтових районів Донбасу і бачили “людське сафарі” на власні очі, надішліть нам свої історії на 📧 <mail>khersonhumansafari@gmail.com</mail>, тема листа: “сафарі на людей”.",
    "type": " Якщо ви стали свідком загибелі друга або сусіда під час атаки дрона і бажаєте поділитися своєю розповіддю, вкажіть «свідок»; якщо ви були безпосередньо атаковані — вкажіть «виживший».",
    "requirements": "<b>Що потрібно:</b> місто/локація, дата атаки, коротка історія (3–6 речень, факти, від першої особи).",
    "honesty": "Будьте чесні, стисло, без секретів військових позицій — можна залишатися анонімним.",
    "media": "<b>Фото/відео?</b> Пишіть “Фото/відео доступні”, файли не надсилайте — ми самі попросимо.",
    "consent": "<b>Згода на публікацію:</b> “Я погоджуюся, щоб ця історія була опублікована публічно на сайті HumanSafari.org”"
  },
  "byCountry": "дивитися за країною",
  "byDate": "дивитися за датою",
  "countries": {
    "australia": "Австралія",
    "austria": "Австрія",
    "bulgaria": "Болгарія",
    "canada": "Канада",
    "czechia": "Чехія",
    "denmark": "Данія",
    "estonia": "Естонія",
    "finland": "Фінляндія",
    "france": "Франція",
    "georgia": "Грузія",
    "germany": "Німеччина",
    "hungary": "Угорщина",
    "italy": "Італія",
    "japan": "Японія",
    "mexico": "Мексика",
    "netherlands": "Нідерланди",
    "norway": "Норвегія",
    "poland": "Польща",
    "romania": "Румунія",
    "spain": "Іспанія",
    "sweden": "Швеція",
    "southAfrica": "Південна Африка",
    "ukraine": "Україна",
    "unitedKingdom": "Велика Британія",
    "usa": "США",
    "ireland": "Ірландія",
    "belgium": "Бельгія"
  },
  "cities": {
    "alicante": {
      "city": "Аліканте",
      "country": "Іспанія",
      "time": "Аліканте - Іспанія, 16:00 - 17:00",
      "location": "Аудиторіо ла Конча, Експланада де Еспанья",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Барселона",
      "country": "Іспанія",
      "time": "Барселона - Іспанія, 12:00 - 14:00",
      "location": "Площа Сант-Жауме",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Берклі",
      "country": "США",
      "time": "Берклі - США, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Берлін",
      "country": "Німеччина",
      "time": "Берлін - Німеччина, 12:00",
      "location": "Темпельгофер Фельд, вхід Леінштрасе / кут Ордерштрасе",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Беттендорф",
      "country": "США",
      "time": "Беттендорф - США, 17:30 - Показ фільму",
      "location": "Публічна бібліотека Беттендорфа",
      "cleanTime": "17:30 - Показ фільму",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Бірмінгем",
      "country": "Велика Британія",
      "time": "Бірмінгем - Велика Британія, 14:00 - 15:30",
      "location": "Будинок Баскервіль, Кембридж Стріт",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Бонн",
      "country": "Німеччина",
      "time": "Бонн - Німеччина, 14:00 - 16:00",
      "location": "Поштштрасе, перед Головним вокзалом",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Бремен",
      "country": "Німеччина",
      "time": "Бремен - Німеччина, 15:00 - 18:00",
      "location": "Площа перед вокзалом (Bahnhofsvorplatz)",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Будапешт",
      "country": "Угорщина",
      "time": "Будапешт - Угорщина, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Чикаго",
      "country": "США",
      "time": "Чикаго - США, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Будівля Wrigley)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Констанца",
      "country": "Румунія",
      "time": "Констанца - Румунія, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Копенгаген",
      "country": "Данія",
      "time": "Копенгаген - Данія, 14:00",
      "location": "Аксельторв",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Даллас",
      "country": "США",
      "time": "Даллас - США, 12:00 - 13:00",
      "location": "Площа міської ратуші Далласа",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Денвер",
      "country": "США",
      "time": "Денвер - США, 12:00",
      "location": "Будівля Капітолію штату Колорадо, західні сходи",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Едінбург",
      "country": "Велика Британія",
      "time": "Едінбург - Велика Британія, 13:00 - 15:00",
      "location": "Монумент герцога Веллінгтона",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Форт-Ворт",
      "country": "США",
      "time": "Форт-Ворт - США, 14:00 - 15:00",
      "location": "Суд округу Таррант",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Гамбург",
      "country": "Німеччина",
      "time": "Гамбург - Німеччина, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Гоутон, Мічиган",
      "country": "США",
      "time": "Гоутон, Мічиган - США, 15:00",
      "location": "Портейдж-Лейк Ліфт-Брідж",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Гельсінкі",
      "country": "Фінляндія",
      "time": "Гельсінкі - Фінляндія, 17:00 - 18:00",
      "location": "Площа Нарінкаторі",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Ідзумо",
      "country": "Японія",
      "time": "Ідзумо - Японія, 13:00",
      "location": "Святиня Ідзумо Тайся, 195 Кіцукіхігаші, Тайшачо",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Ідзумо",
      "country": "Японія",
      "time": "Ідзумо - Японія",
      "location": "Святиня Ідзумо Тайся, 195 Кіцукіхігаші, Тайшачо",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Кемлупс",
      "country": "Канада",
      "time": "Кемлупс - Канада, 15:00 - 16:00",
      "location": "Міська Ратуша",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Київ",
      "country": "Україна",
      "time": "Київ - Україна, 17:00 - 18:00",
      "location": "Майдан Незалежності",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Лейпциг",
      "country": "Німеччина",
      "time": "Лейпциг - Німеччина, 12:00 - 13:00",
      "location": "Віллі-Брандт-Плац",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "Лондон",
      "country": "Велика Британія",
      "time": "Лондон - Велика Британія, 18:30 - Показ фільму",
      "location": "Український Дім, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Показ фільму",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Лос-Анджелес",
      "country": "США",
      "time": "Лос-Анджелес - США, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Малага",
      "country": "Іспанія",
      "time": "Малага - Іспанія, 18:00 - Показ фільму",
      "location": "Майдан - Історико-культурний центр України",
      "cleanTime": "18:00 - Показ фільму",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Манчестер",
      "country": "Велика Британія",
      "time": "Манчестер - Велика Британія, 14:00 - 15:30",
      "location": "Площа Св. Петра, меморіал Еммелін Панкхерст",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Мехіко",
      "country": "Мексика",
      "time": "Мехіко - Мексика, 11:00",
      "location": "Аламеда Сентрал. Фонтан «Америка» (між Hemiciclo Juárez та кіоском)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Мілан",
      "country": "Італія",
      "time": "Мілан - Італія, 15:00",
      "location": "Собор Дуомо",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Мюнхен",
      "country": "Німеччина",
      "time": "Мюнхен - Німеччина, 17:00 - 19:00",
      "location": "Одеонсплац",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "Нью-Йорк",
      "country": "США",
      "time": "Нью-Йорк - США, 16:00",
      "location": "Таймс-Сквер",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "Нью-Йорк",
      "country": "США",
      "time": "Нью-Йорк - США, 13:00 - 14:00",
      "location": "Таймс-Сквер",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Нієнбург (Везер)",
      "country": "Німеччина",
      "time": "Нієнбург (Везер) - Німеччина, 17:00",
      "location": "Штеттінер-штрассе, 2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Осло",
      "country": "Норвегія",
      "time": "Осло - Норвегія, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Естерсунд",
      "country": "Швеція",
      "time": "Естерсунд - Швеція, 11:00 - 14:00",
      "location": "Stortorget (Головна площа)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Оттава",
      "country": "Канада",
      "time": "Оттава - Канада, 12:30 - 13:30",
      "location": "російське посольство",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Оттава",
      "country": "Канада",
      "time": "Оттава - Канада, 12:00",
      "location": "Посольство США",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Париж",
      "country": "Франція",
      "time": "Париж - Франція, 15:30",
      "location": "Площа Тараса Шевченка -> Фонтан Сен-Мішель (марш)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Пловдів",
      "country": "Болгарія",
      "time": "Пловдів - Болгарія, 16:00 - 17:00",
      "location": "Біля будинку Левскі",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Прага",
      "country": "Чехія",
      "time": "Прага - Чехія, 14:00",
      "location": "Площа Палацкеho",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Розендаль",
      "country": "Південна Африка",
      "time": "Розендаль - Південна Африка, 11:00",
      "location": "Офіси поліції Південної Африки",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "Сан-Андрес, Тенеріфе",
      "country": "Іспанія",
      "time": "Сан-Андрес, Тенеріфе - Іспанія, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "Сан-Дієго",
      "country": "США",
      "time": "Сан-Дієго - США, 14:00 - 16:00",
      "location": "Статуя Ель Сід, Бальбоа Парк",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "Сан-Франциско",
      "country": "США",
      "time": "Сан-Франциско - США, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Шверін",
      "country": "Німеччина",
      "time": "Шверін - Німеччина, 19:00 - Показ фільму",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Показ фільму",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Сіетл",
      "country": "США",
      "time": "Сіетл - США, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Светі Влас",
      "country": "Болгарія",
      "time": "Светі Влас - Болгарія, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Сідней",
      "country": "Австралія",
      "time": "Сідней - Австралія, 14:00",
      "location": "Ратуша Сіднея",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Таллінн",
      "country": "Естонія",
      "time": "Таллінн - Естонія, 15:00 - Показ фільму та мітинг",
      "location": "Кінотеатр Sõprus, Vana-Posti tn.8",
      "cleanTime": "15:00 - Показ фільму та мітинг",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Таррагона",
      "country": "Іспанія",
      "time": "Таррагона - Іспанія, 18:30",
      "location": "Балко Медітерані",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "Гаага",
      "country": "Нідерланди",
      "time": "Гаага - Нідерланди, 13:00 - 15:00",
      "location": "Перед Палацом Миру / Міжнародний кримінальний суд",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Тбілісі",
      "country": "Грузія",
      "time": "Тбілісі - Грузія, 21:00",
      "location": "Тбілісі",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Транас",
      "country": "Швеція",
      "time": "Транас - Швеція, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Відень",
      "country": "Австрія",
      "time": "Відень - Австрія, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (поруч зі Штефансдомом)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Вашингтон, D.C.",
      "country": "США",
      "time": "Вашингтон, D.C. - США, 12:30 - 13:30",
      "location": "Білий дім",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Вроцлав",
      "country": "Польща",
      "time": "Вроцлав - Польща, 13:00",
      "location": "Площа Свободи (у напрямку Народного музичного форуму)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Організуйтесь! Щоб додати своє місто, надішліть електронного листа на:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Поділіться на {{platform}}",
    "website": "Вебсайт",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Зарина Забрицька, журналістка та кінорежисерка, очолила всесвітню демонстрацію та зняла документальний фільм Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Захист цивільних для вулиць Херсона — захист мирних жителів від атак дронів.",
      "foodDesc": "Продовольча допомога.",
      "foodNote": "Під час пожертви вкажіть у призначенні платежу «Food for Cherson»."
    },
    "ahs": {
      "name": "Проєкт Anti Human Safari",
      "desc": "Детектори дронів та захисні жилети для волонтерів та служб екстреної допомоги в Херсоні."
    },
    "pageTitle": "Зупинімо Human Safari",
    "sectionIntro": "З літа 2024 року російські військові використовують малі дрони для полювання, вбивств та тероризування мирних жителів на вулицях Херсона та інших прифронтових міст України.",
    "sectionIntro2": "Це систематична й умисна кампанія вбивств: російські оператори дронів відкрито публікують відео своїх жертв у Telegram-каналах, щоб похизуватися. У травні 2025 року ООН визнала Human Safari триваючим воєнним злочином.",
    "sectionIntro3": "Робиться надто мало. Human Safari треба зупинити.",
    "sectionIntroBold": "ВИ можете допомогти. Ось як",
    "step2Title": "Організуйте",
    "step3Title": "Розкажіть іншим",
    "step3Para": "Використовуйте хештеги",
    "step3ParaPost": "і розповідайте іншим про Human Safari",
    "instagram": "Instagram",
    "step2Bullet1": "кінопоказ",
    "step2Bullet2": "публічна акція",
    "step2Bullet3": "висвітлення в медіа",
    "publicActionLead": "Привертайте увагу до «людського сафарі» там, де ви є.",
    "reachOutPre": "Ви можете",
    "reachOut": "звернутися",
    "reachOutPost": "по ідеї та ресурси",
    "newsCoverageLead": "через ваші медійні контакти. Розкажіть їм про «людське сафарі» та про загрозу для всіх нинішніх і майбутніх зон конфлікту.",
    "putInTouchPre": "Ви також можете",
    "putInTouch": "звести нас напряму",
    "inform": "Дізнайтесь",
    "informSub": "себе та інших",
    "policyTitle": "Політика",
    "policyBody": "Запропонований закон LORA (Liability for Operators and Responsible Authorities Act) запровадив би санкції по всьому ланцюгу відповідальності — від російських операторів FPV-дронів і командирів до вищого військового керівництва, а також проти виробників і постачальників, які уможливлюють виробництво та застосування дронів проти цивільних.",
    "policyHelp": "Ви можете допомогти на політичному рівні?",
    "getInTouch": "Зв'яжіться з нами",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "donate": "Задонатити",
    "donateIntro": "Це ініціативи, які надають дієву й адресну допомогу, щоб безпосередньо захищати цивільних Херсона від Human Safari.",
    "shareTitle": "Поширте інформацію",
    "filmScreening": "Організуйте показ документального фільму «Херсонське людське сафарі»:",
    "howItStarted": "Як це почалося",
    "kryla": {
      "name": "Благодійний фонд «Крила»",
      "desc": "Підтримайте їх, щоб оплатити житло та найнеобхідніше для мешканців Олешок."
    }
  },
  "action": {
    "intro": "Ми почали зі світової демонстрації. Тепер ви можете:",
    "helpLink": "допомогти тут"
  },
  "accounts": {
    "heading": "Свідчення"
  },
  "media": {
    "close": "Закрити",
    "view": "Переглянути медіа",
    "previous": "Попереднє",
    "next": "Наступне",
    "andrushenkoCredit": "Олександр Андрющенко, фотокореспондент медіа «Вгору»",
    "khersonPoliceCredit": "від @khersonpolice",
    "antypenkoCredit": "Іван Антипенко, фотожурналіст із Херсона",
    "telegramChannelCredit": "опубліковано в російському Telegram-каналі людського сафарі «від Маріуполя до Карпат»",
    "fruitSellerDescription": "Продавця фруктів переслідує дрон на оптоволокні",
    "burntCarDescription": "Згорілий автомобіль у Херсоні",
    "bridgeAttackDescription": "Підлітка вбито FPV-дроном під мостом у Херсоні",
    "busAttackDescription": "Одна з багатьох атак FPV-дронів на громадський транспорт",
    "fpvDroneDescription": "FPV-дрон на полюванні «Human Safari»",
    "antiDroneNetsDescription": "Херсонська вулиця, накрита сітками від дронів «Human Safari»",
    "firefighterDescription": "Рятувальник гасить автомобіль після удару «Human Safari», позаду лежить постраждалий"
  },
  "follow": {
    "title": "Стежте",
    "subHumanSafari": "якісні джерела, які повідомляють із Херсона та про «людське сафарі»",
    "subDroneSiege": "якісні джерела, які повідомляють із Херсона та про дронову облогу",
    "localPress": "місцева україномовна преса",
    "lang": {
      "english": "англійська",
      "german": "німецька",
      "ukrainian": "українська"
    },
    "language": "Мова: {{list}}",
    "languages": "Мови: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Зарина Забріскі",
      "desc": "Американська журналістка й режисерка в Херсоні, працює для Byline Times та Euromaidan Press; режисерка документального фільму Kherson Human Safari."
    },
    "naber": {
      "name": "Ібрагім Набер",
      "desc": "Головний репортер німецької газети Die Welt; періодично висвітлює «людське сафарі» в Херсоні."
    },
    "kelley": {
      "name": "Брендан Келлі",
      "desc": "Веде Kherson Weekly — хроніку російських атак дронами на цивільних у Херсоні та навколишніх селах."
    },
    "vgoru": {
      "name": "Вгору",
      "desc": "Незалежна медіаплатформа Херсонщини — про життя під обстрілами та в окупації."
    },
    "suspilne": {
      "name": "Суспільне Херсон",
      "desc": "Херсонська редакція Суспільного мовника України."
    },
    "most": {
      "name": "МОСТ",
      "desc": "Місцеве херсонське інформаційне агентство — про місто й область."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "ЗУПИНИМО ДРОНОВУ ОБЛОГУ",
      "heroSave": "ВРЯТУЙТЕ ОЛЕШКИ",
      "worldwideRally": "світова акція",
      "heroDate": "Жовтень",
      "infoText1": "Тисячі цивільних опинилися в пастці дронової облоги в Олешках, Голій Пристані, Старій Збур'ївці та Новій Збур'ївці. Російські війська використовують їх як живий щит, ховаючись за ними, щоб здійснювати дронові атаки «сафарі на людей» на протилежний берег.",
      "infoText2": "Криза гостра: бракує їжі, води, медичної допомоги, ліків, електрики, газу та зв'язку. Дороги густо заміновані, а дрони обмежують будь-який рух. <bold>ВИ можете допомогти. Приєднуйтесь до тисяч людей по всьому світу, щоб вимагати зупинити дронову облогу.</bold>",
      "imageAlt": "Виснажений собака серед людських кісток у зруйнованих Олешках під червоним небом, повним дронів, з написом Stop Russian Drone Siege",
      "demandsTitle": "Ми закликаємо до:",
      "demand1": "безпечних та ефективних гуманітарних коридорів до Олешок та інших постраждалих громад.",
      "demand2": "негайної гуманітарної допомоги та підтримки жертвам атак «людського сафарі».",
      "demand3": "відповідних санкцій проти осіб і ланцюгів постачання, відповідальних за атаки на цивільних.",
      "demand4": "заходів, що стримуватимуть використання малих дронів для систематичних атак на цивільних і їх тероризування в Херсоні, в Україні та деінде.",
      "cities": {
        "edinburgh": {
          "city": "Едінбург",
          "country": "Велика Британія",
          "time": "Едінбург - Велика Британія, 14:00",
          "location": "Монумент герцога Веллінгтона",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Бірмінгем",
          "country": "Велика Британія",
          "time": "Бірмінгем - Велика Британія, 14:00 - 16:00",
          "location": "Навпроти Зали пам'яті (Hall of Memory), B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Відень",
          "country": "Австрія",
          "time": "Відень - Австрія, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Мюнхен",
          "country": "Німеччина",
          "time": "Мюнхен - Німеччина, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 16:00 - 18:00",
          "location": "Даунінг-стріт",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Манчестер",
          "country": "Велика Британія",
          "time": "Манчестер - Велика Британія, 14:00 - 15:30",
          "location": "Площа Святого Петра (St Peter's Square)",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Сідней",
          "country": "Австралія",
          "time": "Сідней - Австралія, 14:00",
          "location": "Ратуша Сіднея (Sydney Town Hall)",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Париж",
          "country": "Франція",
          "time": "Париж - Франція, 15:30 - 18:30",
          "location": "Від церкви Святого Володимира до площі Сен-Мішель",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Париж",
          "country": "Франція",
          "time": "Париж - Франція, 18:00",
          "location": "Станція метро «Рамбюто»",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Ліон",
          "country": "Франція",
          "time": "Ліон - Франція, 14:00",
          "location": "Площа Комедії (Place de la Comédie)",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Дублін",
          "country": "Ірландія",
          "time": "Дублін - Ірландія, 13:00",
          "location": "Головпоштамт (The GPO)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Брюссель",
          "country": "Бельгія",
          "time": "Брюссель - Бельгія, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Брюссель (кільце Шуман)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Оттава",
          "country": "Канада",
          "time": "Оттава - Канада, 12:30 - 13:30",
          "location": "Посольство росії, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Нант",
          "country": "Франція",
          "time": "Нант - Франція, 15:00 - 16:30",
          "location": "Королівська площа (Place Royale)",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Гданськ",
          "country": "Польща",
          "time": "Гданськ - Польща, 18:30 - 19:30",
          "location": "Długi Targ, біля фонтану Нептуна",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Чикаго",
          "country": "США",
          "time": "Чикаго - США, 13:00",
          "location": "410 N. Michigan ave. (Будівля Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Чикаго",
          "country": "США",
          "time": "Чикаго - США, 13:00",
          "location": "410 N. Michigan ave. (Будівля Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Чикаго",
          "country": "США",
          "time": "Чикаго - США, 13:00",
          "location": "410 N. Michigan ave. (Будівля Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Чикаго",
          "country": "США",
          "time": "Чикаго - США, 13:00",
          "location": "410 N. Michigan ave. (Будівля Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Дрезден",
          "country": "Німеччина",
          "time": "Дрезден - Німеччина, 14:00",
          "location": "Ноймаркт (Neumarkt)",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Малага",
          "country": "Іспанія",
          "time": "Малага - Іспанія, 19:00",
          "location": "Площа Марина (Plaza de la Marina)",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 18:00",
          "location": "Трафальгарська площа",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Пловдив",
          "country": "Болгарія",
          "time": "Пловдив - Болгарія, 17:00",
          "location": "Головна вулиця, біля сходів «Каменица» / напису «Together»",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Будапешт",
          "country": "Угорщина",
          "time": "Будапешт - Угорщина, 17:00 - 20:00",
          "location": "Szent István tér (площа Святого Іштвана)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 17:00",
          "location": "Трафальгарська площа",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 12:00",
          "location": "Трафальгарська площа",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Гамбург",
          "country": "Німеччина",
          "time": "Гамбург - Німеччина, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, навпроти причалу 1, 20359 Гамбург",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Кіль",
          "country": "Німеччина",
          "time": "Кіль - Німеччина, 15:00 - 16:00",
          "location": "Гольштенштрасе (Holstenstraße)",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Осло",
          "country": "Норвегія",
          "time": "Осло - Норвегія",
          "location": "Площа Ейдсволла (Eidsvolls plass)",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Лейпциг",
          "country": "Німеччина",
          "time": "Лейпциг - Німеччина, 17:00 - 18:00",
          "location": "Головний вокзал (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 17:00",
          "location": "Трафальгарська площа",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "Лондон",
          "country": "Велика Британія",
          "time": "Лондон - Велика Британія, 13:00",
          "location": "Трафальгарська площа",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Дублін",
          "country": "Ірландія",
          "time": "Дублін - Ірландія, 13:00",
          "location": "Головпоштамт (The GPO)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Дублін",
          "country": "Ірландія",
          "time": "Дублін - Ірландія, 14:00",
          "location": "Головпоштамт (The GPO)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Нант",
          "country": "Франція",
          "time": "Нант - Франція, 15:00 - 16:30",
          "location": "Королівська площа (Place Royale)",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Зупиніть російську дронову облогу",
      "posterNoRoadOut": "Шляхи в Олешки та з них заблоковані",
      "posterHumanitarianCatastrophe": "Олешки. Гуманітарна катастрофа під окупацією",
      "seeGallery": "Переглянути / завантажити плакати"
    },
    "artBy": "Автор: {{name}}",
    "downloadPoster": "Завантажити плакат",
    "reel": {
      "download": "Завантажити відео (MP4)"
    },
    "addDemo": {
      "title": "додайте свою акцію",
      "where": "де: місто",
      "contact": "email/номер",
      "message": "повідомлення: кого ви представляєте, акцію підтверджено чи вона в процесі, посилання на онлайн-оголошення, інші деталі",
      "submit": "Надіслати",
      "sending": "Надсилання…",
      "thanks": "Дякуємо! Ми з вами зв'яжемося.",
      "error": "Щось пішло не так. Спробуйте ще раз.",
      "contactInvalid": "Введіть дійсний email або номер телефону з кодом країни (наприклад, +380 67 123 4567).",
      "date": "дата",
      "time": "час початку (місцевий)",
      "whereInvalid": "Введіть назву міста, наприклад Київ або Париж, Франція.",
      "datePlaceholder": "дата: дд/мм"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Зупинимо дронову облогу — Врятуйте Олешки | Акції у світі",
      "description": "Російські дрони тримають в облозі тисячі цивільних в окупованих Олешках, відрізаних від їжі, води та ліків. Знайдіть акцію поруч і вимагайте безпечного виходу."
    },
    "leftBank": {
      "title": "Дронова облога Олешок та окупованої Херсонщини",
      "description": "Тисячі цивільних опинилися в пастці російської дронової облоги в окупованих Олешках, Голій Пристані та довколишніх селах. Дізнайтеся, що відбувається і як допомогти."
    },
    "help": {
      "title": "Зупинімо Human Safari — російські дрони полюють на цивільних у Херсоні",
      "description": "Російські дрони полюють на цивільних у Херсоні. Дізнайтеся про воєнний злочин Human Safari та як допомогти його зупинити."
    },
    "action": {
      "title": "Світова акція, грудень 2025 — Зупинімо Human Safari",
      "description": "Фото, плакати та місця світової акції у грудні 2025 року проти російських атак дронів на цивільних у Херсоні."
    },
    "rallies": {
      "title": "Фото з акцій — Зупинімо Human Safari",
      "description": "Фото з акцій у всьому світі проти російських атак дронів на цивільних у Херсоні."
    },
    "resources": {
      "title": "Human Safari — звіти, статті та свідчення",
      "description": "Звіти, статті, інтерв’ю та свідчення очевидців про російські атаки дронів на цивільних у Херсоні."
    },
    "reel": {
      "title": "Врятуйте Олешки — відео з акцій",
      "description": "Відео зі світових акцій «Врятуйте Олешки», жовтень 2026."
    }
  }
}
